import React, { useState, useEffect } from 'react'
import { isEmpty, get } from 'lodash'
import { callApi } from '../../utils/api';
import { toast } from 'react-toastify';

const AddPolicy = (props) => {
  const { policy, onBack, isEdit } = props
  const [ tempPolicyList, setTempPolicyList ] = useState([ policy ]);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isBackLoading, setIsBackLoading ] = useState(false);

  const handleAddNewPolicy = () => {
    let newPolicyList = JSON.parse(JSON.stringify(tempPolicyList))
    newPolicyList = [ ...newPolicyList, { policy: '' } ]
    setTempPolicyList(newPolicyList)
  }

  const handlePolicyChange = (value, index) => {
    let newPolicyList = JSON.parse(JSON.stringify(tempPolicyList))
    newPolicyList[index] = {
      ...newPolicyList[index],
      policy: value
    };
    setTempPolicyList(newPolicyList)
  }

  const handleDeletePolicy = (index) => {
    let newPolicyList = JSON.parse(JSON.stringify(tempPolicyList))
    newPolicyList.splice(index, 1)
    if (newPolicyList.length <= 0) {
      newPolicyList = [ ...newPolicyList, { policy: '' } ]
    }
    setTempPolicyList(newPolicyList)
  }

  const handleBackClick = () => {
    if (isBackLoading) {
      return;
    }
    setIsBackLoading(true);
    requestAnimationFrame(() => {
      onBack();
    });
  }

  const getTrimmedPolicyList = () => {
    return tempPolicyList.map(tempPolicy => ({
      ...tempPolicy,
      policy: (tempPolicy.policy || '').trim()
    }));
  };

  const hasValidPolicies = () => {
    const policyList = getTrimmedPolicyList();
    return policyList.length > 0 && policyList.every(tempPolicy => tempPolicy.policy);
  };

  const handleSavePolicy = () => {
    const policyList = getTrimmedPolicyList();
    if (policyList.length === 0 || !policyList.every(tempPolicy => tempPolicy.policy)) {
      toast.error('Policy name is required', { autoClose: 2000 });
      return;
    }
    setIsLoading(true);
    callApi("POST", "policy_update.php", { data: [ ...policyList ] })
      .then(res => res.data)
      .then(response => {
        if (
          response.result === false ||
          (response.message && response.message.indexOf('Already Exist') !== -1)
        ) {
          toast.error(response.message || 'Failed to save policy', { autoClose: 2000 });
          return;
        }
        toast.success(response.message || 'Policy saved successfully', { autoClose: 2000 });
        onBack();
      })
      .catch(err => {
        console.log(err);
        toast.error('Something went wrong, please try again', { autoClose: 2000 });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div className="policymain-container">
      <div className="pcoded-content">
        <div className="card">
          <div className="card-header display-flex align-items-center policy-header">
            <button className="btn policy-back-button" disabled={isBackLoading} onClick={handleBackClick}>
              {isBackLoading ? (
                <i className="fa fa-spinner fa-spin" aria-hidden="true" />
              ) : (
                <i className="feather icon-arrow-left"></i>
              )}
            </button>
            <h5>{isEdit ? 'Edit Policy' : 'Add Policy'}</h5>
          </div>
          <div className="card-body">
            {tempPolicyList.map((temppolicy, index) => {
              return (
                <div className="display-flex flex-align-center policy-input-wrapper" key={index}>
                  <textarea type="text" name={`policy-${index}`} className="form-control policy-input" value={temppolicy.policy} onChange={event => handlePolicyChange(event.target.value, index)} />
                  {!isEdit && <div className="col-md-1 policy-button">
                    <button disabled={isEmpty(temppolicy.policy)} onClick={() => handleDeletePolicy(index)} className="btn btn-icon btn-rounded btn-danger">
                      <i className="feather icon-minus" />
                    </button>
                  </div>}
                </div>
              )
            })}
            {!isEdit && <div className="col-md-1 add-policy-button policy-button">
              <button className="btn btn-icon btn-rounded btn-primary" onClick={handleAddNewPolicy}><i className="feather icon-plus"></i></button>
            </div>}
            <div className="float-right">
              <button className="btn btn-success" onClick={handleSavePolicy} disabled={!hasValidPolicies() || isLoading}>
                {isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddPolicy